import type { MindmapDocument } from "../types";
import { createDateColumn, createStringColumn } from "./columnHelpers";
import { createLinkColumn } from "./linkColumnHelper";

const namespace = "mindmaps";

export const mindmapsColumns = [
    createStringColumn<MindmapDocument>({
        namespace,
        field: "metadata.mindmap",
        header: "ID",
    }),
    createStringColumn<MindmapDocument>({
        namespace,
        field: "metadata.title",
        header: "Title",
    }),
    createStringColumn<MindmapDocument>({
        namespace,
        field: "metadata.file_name",
        header: "File Name",
    }),
    createDateColumn<MindmapDocument>({
        namespace,
        field: "metadata.ingestion_date",
        header: "Ingestion Date",
    }),
    createLinkColumn<MindmapDocument>({
        namespace,
        field: "metadata.source",
        header: "Source",
    }),
];
